import { Component, Input } from "@angular/core";

/** Empty, loading, and error states shared by lists. */
@Component({
  selector: "app-rhero-state",
  standalone: true,
  template: `
    @if (mode === "loading") {
      <div class="rhero-state" role="status" aria-live="polite">
        <span class="rhero-skel"></span>
        <span class="rhero-skel"></span>
        <span class="rhero-skel short"></span>
        <p>Loading {{ label }}…</p>
      </div>
    } @else if (mode === "error") {
      <div class="rhero-state rhero-state-error" role="alert">
        <p>{{ message || "This list could not be loaded." }}</p>
      </div>
    } @else {
      <div class="rhero-state">
        <p>{{ message || "Nothing to show." }}</p>
      </div>
    }
  `
})
export class RheroStateComponent {
  @Input() mode: "empty" | "loading" | "error" = "empty";
  @Input() label = "records";
  @Input() message = "";
}
